// Map of the CFO's office AI/tech stack.
// Each layer contains categories; each category maps to case study IDs
// from /app/frontend/src/data/caseStudies.js
//
// Tiers roughly follow: Front office → Order-to-Cash → Procure-to-Pay
// → Record-to-Report → Treasury & Ops.

export const CFO_STACK = [
  {
    tierKey: "front-office",
    tierLabel: "Front office",
    tierBlurb: "The CFO and their leverage tools.",
    categories: [
      {
        key: "personal-productivity",
        label: "Personal Productivity",
        icon: "Sparkles",
        accent: "sky",
        blurb: "AI copilots, meeting intel, exec briefings.",
        cases: [],
      },
      {
        key: "planning-budgeting",
        label: "Planning & Budgeting (FP&A)",
        icon: "LineChart",
        accent: "emerald",
        blurb: "Forecasting, scenarios, rolling budgets.",
        cases: [],
      },
    ],
  },
  {
    tierKey: "order-to-cash",
    tierLabel: "Order to cash",
    tierBlurb: "Quote → contract → bill → collect.",
    categories: [
      {
        key: "contracts",
        label: "Contracts (CLM)",
        icon: "FileSignature",
        accent: "sky",
        blurb: "AI clause extraction, lifecycle, e-sign.",
        cases: [],
      },
      {
        key: "ar-billing",
        label: "AR & Billing",
        icon: "Receipt",
        accent: "emerald",
        blurb: "Usage-based billing, invoicing, receivables.",
        cases: [
          "bluecopa-yatra",
          "bluecopa-porter",
          "bluecopa-purplle",
          "bluecopa-diversey",
          "bluecopa-premier-ecommerce",
          "bluecopa-ekacare",
          "bluecopa-global-hr-saas",
          "zenskar-100ms",
          "zenskar-yembo",
          "zenskar-squadstack",
          "zenskar-pontera",
          "zenskar-indigov",
          "zenskar-thriva",
          "zenskar-cyflare",
        ],
      },
      {
        key: "credit-underwriting",
        label: "Credit & Underwriting",
        icon: "Scale",
        accent: "amber",
        blurb: "Credit decisioning, fraud, loan ops.",
        cases: [],
      },
    ],
  },
  {
    tierKey: "procure-to-pay",
    tierLabel: "Procure to pay",
    tierBlurb: "Source → PO → invoice → pay.",
    categories: [
      {
        key: "procurement",
        label: "Procurement & Spend",
        icon: "ShoppingBag",
        accent: "amber",
        blurb: "SaaS spend, sourcing, supplier ops.",
        cases: [],
      },
      {
        key: "ap",
        label: "Accounts Payable",
        icon: "CreditCard",
        accent: "emerald",
        blurb: "Invoice capture, approvals, vendor payments.",
        cases: [],
      },
      {
        key: "idp",
        label: "Document Intake / IDP",
        icon: "ScanLine",
        accent: "sky",
        blurb: "OCR + IDP for statements, POs, tickets.",
        cases: [],
      },
    ],
  },
  {
    tierKey: "record-to-report",
    tierLabel: "Record to report",
    tierBlurb: "Close, consolidate, report.",
    categories: [
      {
        key: "close-consolidation",
        label: "Close & Consolidation",
        icon: "Layers",
        accent: "emerald",
        blurb: "GL mapping, group consolidation, MIS.",
        cases: [
          "finahq-neuberg",
          "finahq-veranda",
          "finahq-swelect",
          "finahq-snr",
          "finahq-samayanallur",
          "zenstatement-teabox",
          "triam-barrix",
          "triam-va-consulting",
          "triam-tefty",
        ],
      },
      {
        key: "tax-compliance",
        label: "Tax & Compliance",
        icon: "ShieldCheck",
        accent: "amber",
        blurb: "GST/VAT automation, filings, audit trails.",
        cases: [],
      },
    ],
  },
  {
    tierKey: "treasury-ops",
    tierLabel: "Treasury & Ops",
    tierBlurb: "Cash, cards, disbursements.",
    categories: [
      {
        key: "payments-cards",
        label: "Payments & Cards",
        icon: "Wallet",
        accent: "sky",
        blurb: "Card issuance, wallets, disbursements.",
        cases: [],
      },
      {
        key: "treasury",
        label: "Treasury & Cash",
        icon: "PiggyBank",
        accent: "emerald",
        blurb: "Cash forecasting, banking, working capital.",
        cases: [],
      },
    ],
  },
];

export const getCategoryByKey = (key) => {
  for (const tier of CFO_STACK) {
    const cat = tier.categories.find((c) => c.key === key);
    if (cat) return { ...cat, tierLabel: tier.tierLabel, tierKey: tier.tierKey };
  }
  return null;
};

export const flatCategories = () =>
  CFO_STACK.flatMap((t) =>
    t.categories.map((c) => ({ ...c, tierLabel: t.tierLabel, tierKey: t.tierKey }))
  );
